import type { VariantProps } from 'tailwind-variants'
import { tv } from 'tailwind-variants'

export const container = tv({
  slots: {
    root: 'mx-auto',
  },
  variants: {
    variant: {
      content: {
        root: 'max-w-7xl',
      },
    },
    fullWidth: {
      true: {
        root: 'w-screen max-w-full',
      },
    },
    noPadding: {
      false: {
        root: 'px-4 sm:px-6 lg:px-8',
      },
    },
    hasGaps: {
      true: {
        root: 'gap-6 sm:gap-7 lg:gap-8',
      },
    },
  },
  defaultVariants: {
    variant: 'content',
  },
})

type ContainerUiVariants = VariantProps<typeof container>
type ContainerUiSlots = Partial<typeof container.slots>
export type { ContainerUiSlots, ContainerUiVariants }
